function smoothScrollTo(endX, endY, duration) {
    window.scrollTo(endX, endY);
}

export default smoothScrollTo;
